const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                    ['content_start', [this, 'block_content_start']],
                    ['content', [this, 'block_content']],
                    ['content_end', [this, 'block_content_end']]
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                context.proxy[`tag_name`] = (((context.has(`tag_name`))) ? (this.env.getFilter('default').traceableCallable(1, this.source)(...[(context.has(`tag_name`) ? context.get(`tag_name`) : null), (((context.has(`href`) ? context.get(`href`) : null)) ? (`a`) : (`button`))])) : ((((context.has(`href`) ? context.get(`href`) : null)) ? (`a`) : (`button`))));
                context.proxy[`_content_start`] =                 this.traceableRenderBlock(3, this.source)(`content_start`, context.clone(), blocks);
                context.proxy[`_content_end`] =                 this.traceableRenderBlock(4, this.source)(`content_end`, context.clone(), blocks);
                if (!!(!!(!!(!!(this.isIn(`is-slashed`, (context.has(`class`) ? context.get(`class`) : null)) && this.env.getTest('empty').traceableCallable(8, this.source)(...[(context.has(`content_start_icon`) ? context.get(`content_start_icon`) : null)])) && this.env.getTest('empty').traceableCallable(9, this.source)(...[(context.has(`content_end_icon`) ? context.get(`content_end_icon`) : null)])) && this.env.getTest('empty').traceableCallable(10, this.source)(...[this.env.getFilter('trim').traceableCallable(10, this.source)(...[(context.has(`_content_start`) ? context.get(`_content_start`) : null)])])) && this.env.getTest('empty').traceableCallable(12, this.source)(...[this.env.getFilter('trim').traceableCallable(11, this.source)(...[(context.has(`_content_end`) ? context.get(`_content_end`) : null)])]))) {
                    this.echo(`  `);
                    context.proxy[`content_start_icon`] = `bell`;
                }
                this.echo(`
<`);
                this.echo(this.env.getFilter('escape').traceableCallable(16, this.source)(...[this.env, (context.has(`tag_name`) ? context.get(`tag_name`) : null), `html`, null, true]));
                this.echo(`
  class="c-button`);
                if ((context.has(`class`) ? context.get(`class`) : null)) {
                    this.echo(` `);
                    this.echo(this.env.getFilter('escape').traceableCallable(17, this.source)(...[this.env, (context.has(`class`) ? context.get(`class`) : null), `html`, null, true]));
                }
                this.echo(`"
  `);
                if ((context.has(`aria_disabled`) ? context.get(`aria_disabled`) : null)) {
                    this.echo(`    aria-disabled="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(19, this.source)(...[this.env, (context.has(`aria_disabled`) ? context.get(`aria_disabled`) : null), `html`, null, true]));
                    this.echo(`"
  `);
                }
                this.echo(`  `);
                if ((context.has(`aria_expanded`) ? context.get(`aria_expanded`) : null)) {
                    this.echo(`    aria-expanded="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(22, this.source)(...[this.env, (context.has(`aria_expanded`) ? context.get(`aria_expanded`) : null), `html`, null, true]));
                    this.echo(`"
  `);
                }
                this.echo(`  `);
                if (this.compare((context.has(`tag_name`) ? context.get(`tag_name`) : null), `a`)) {
                    this.echo(`    href="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(25, this.source)(...[this.env, (((context.has(`href`))) ? (this.env.getFilter('default').traceableCallable(25, this.source)(...[(context.has(`href`) ? context.get(`href`) : null), `#`])) : (`#`)), `html`, null, true]));
                    this.echo(`"
  `);
                }
                else if (this.compare((context.has(`tag_name`) ? context.get(`tag_name`) : null), `button`)) {
                    this.echo(`    `);
                    if ((context.has(`type`) ? context.get(`type`) : null)) {
                        this.echo(`type="`);
                        this.echo(this.env.getFilter('escape').traceableCallable(27, this.source)(...[this.env, (context.has(`type`) ? context.get(`type`) : null), `html`, null, true]));
                        this.echo(`"`);
                    }
                    this.echo(`    `);
                    if ((context.has(`disabled`) ? context.get(`disabled`) : null)) {
                        this.echo(`      disabled
    `);
                    }
                    this.echo(`  `);
                }
                this.echo(`>
  `);
                if (!!(this.env.getFilter('trim').traceableCallable(33, this.source)(...[(context.has(`_content_start`) ? context.get(`_content_start`) : null)]) || (context.has(`content_start_icon`) ? context.get(`content_start_icon`) : null))) {
                    this.echo(`    <span class="c-button__extra">
      `);
                    this.traceableDisplayBlock(35, this.source)('content_start', context.clone(), blocks);
                    this.echo(`    </span>
  `);
                }
                this.echo(`  <span class="c-button__content">
    `);
                this.traceableDisplayBlock(45, this.source)('content', context.clone(), blocks);
                this.echo(`  </span>
  `);
                if (!!(this.env.getFilter('trim').traceableCallable(49, this.source)(...[(context.has(`_content_end`) ? context.get(`_content_end`) : null)]) || (context.has(`content_end_icon`) ? context.get(`content_end_icon`) : null))) {
                    this.echo(`    <span class="c-button__extra">
      `);
                    this.traceableDisplayBlock(51, this.source)('content_end', context.clone(), blocks);
                    this.echo(`    </span>
  `);
                }
                this.echo(`</`);
                this.echo(this.env.getFilter('escape').traceableCallable(60, this.source)(...[this.env, (context.has(`tag_name`) ? context.get(`tag_name`) : null), `html`, null, true]));
                this.echo(`>
`);
            }

            block_content_start(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`        `);
                if ((context.has(`content_start_icon`) ? context.get(`content_start_icon`) : null)) {
                    this.echo(`          `);
                    this.echo(this.include(context, this.source, `@cloudfour/components/icon/icon.twig`, new Map([[`name`, (context.has(`content_start_icon`) ? context.get(`content_start_icon`) : null)]]), false, false, 37));
                    this.echo(`        `);
                }
                this.echo(`      `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`      `);
                this.echo(this.env.getFilter('escape').traceableCallable(46, this.source)(...[this.env, (((context.has(`label`))) ? (this.env.getFilter('default').traceableCallable(46, this.source)(...[(context.has(`label`) ? context.get(`label`) : null), `Hello world`])) : (`Hello world`)), `html`, null, true]));
                this.echo(`
    `);
            }

            block_content_end(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`        `);
                if ((context.has(`content_end_icon`) ? context.get(`content_end_icon`) : null)) {
                    this.echo(`          `);
                    this.echo(this.include(context, this.source, `@cloudfour/components/icon/icon.twig`, new Map([[`name`, (context.has(`content_end_icon`) ? context.get(`content_end_icon`) : null)]]), false, false, 53));
                    this.echo(`        `);
                }
                this.echo(`      `);
            }

            getTemplateName() {
                return `d83fe454cd20fd336c8b5bf0737afcf546d2cfef71896a6360be1222be90a7a1`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `d83fe454cd20fd336c8b5bf0737afcf546d2cfef71896a6360be1222be90a7a1`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'd83fe454cd20fd336c8b5bf0737afcf546d2cfef71896a6360be1222be90a7a1');

let template = env.loadTemplate('d83fe454cd20fd336c8b5bf0737afcf546d2cfef71896a6360be1222be90a7a1');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/button/button.twig", args: context }
     );
     return rendered;;
};